import {
  ScheduledTask,
  ScheduledTaskListResponse
} from "../pages/task/entities/scheduledTask/ScheduledTaskList";
import { ScheduleTaskEdit } from "../pages/task/entities/scheduledTask/ScheduleTaskEdit";
import { ScheduledTaskListRequest } from "../pages/task/entities/scheduledTask/ScheduledTaskListRequest";
import CompanyService from "./CompanyService";
import RequestService from "./RequestService";

export class ScheduledTaskService {
  public static getScheduledTaskList(
    request: ScheduledTaskListRequest
  ): Promise<ScheduledTaskListResponse | Error> {
    return RequestService.post("/scheduledtask/list", {
      ...request,
      additionaldefinitions: CompanyService.getAdditionalDefinitions()
    });
  }
  public static setScheduledTask(
    request: ScheduleTaskEdit,
    loggedUserId: string
  ) {
    const userResponsibleIsNotLoggedUser =
      request.responsibleUserID && request.responsibleUserID !== loggedUserId;
    request.notifyCompleted = Boolean(
      userResponsibleIsNotLoggedUser && request.notifyCompleted
    );
    return RequestService.post("/scheduledtask/set", { Item: request });
  }
  public static deleteScheduledTask(id: number) {
    return RequestService.post("/scheduledtask/delete", { id });
  }
  public static processScheduledTask(id: number) {
    return RequestService.post("/scheduledtask/process", { id });
  }

  public static getScheduledTask(id: number): Promise<ScheduledTask | Error> {
    return RequestService.post("/scheduledtask/get", { id });
  }
}
